/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
import {
  Box,
  MenuItem,
  IconButton,
  TextField,
  InputAdornment,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Close";

import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { commonHeaderLinkLists } from "helper/PatientManagementHelper/PatientManagementHelper";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import {
  getDateFormatInSpanish,
  mergeListById,
} from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { assetImages } from "constants";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AssignUserModal from "components/Common/Modal/AssignUserModal";
import BloodPressureHeader from "./Header/BloodPressureHeader";
import VitalCommonheader from "../Common/Header/VitalCommonheader";
import SaveBloodPressurePopup from "./Popup/SaveBloodPressurePopup";

const BloodPressureBody = () => {
  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [bloodPressureList, setBloodPressureList] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [selectedBloodPressureIds, setSelectedBloodPressureIds] = useState([]);
  const [selectedBloodPressureId, setSelectedBloodPressureId] = useState(null);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //get all blood pressure
  const getAllBloodPressure = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_BLOOD_PRESSURE;

      const response = await getData(requestUrl);

      setIsLoading(false);

      if (response.status) {
        const { listrecords } = response.data;
        setBloodPressureList(listrecords);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  //update blood pressure
  const updateBulkBloodPressureHandler = async () => {
    if (selectedBloodPressureIds.length > 0) {
      try {
        const bloodPressureListToBeUpdate = bloodPressureList.filter((item) =>
          selectedBloodPressureIds.includes(item._id)
        );

        let bloodPressureData = {
          bloodpressurelist: bloodPressureListToBeUpdate,
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_UPDATE_BULK_BLOOD_PRESSURE +
          ``;

        const response = await putData(requestURL, bloodPressureData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setSelectedBloodPressureIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one blood pressure");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //delete blood pressure
  const deleteBulkBloodPressureHandler = async () => {
    if (selectedBloodPressureIds.length > 0) {
      try {
        const bloodPressureListToBeDelete = bloodPressureList.filter((item) =>
          selectedBloodPressureIds.includes(item._id)
        );

        let bloodPressureData = {
          bloodpressurelist: bloodPressureListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_BULK_BLOOD_PRESSURE +
          ``;

        const response = await putData(requestURL, bloodPressureData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setBloodPressureList((prevList) =>
              prevList.filter(
                (item) => !selectedBloodPressureIds.includes(item._id)
              )
            );

            setSelectedBloodPressureIds([]);
            setRowSelection({});
          }, 1500);
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one blood pressure");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  const afterActionClose = (data = []) => {
    setBloodPressureList((prevList) => mergeListById(prevList, data));
  };

  useEffect(() => {
    getAllBloodPressure();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        size: 70,
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveBloodPressureOffCanvas"
            aria-controls="saveBloodPressureOffCanvas"
            onClick={() => {
              setSelectedBloodPressureId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        header: "Systolic",
        accessorKey: "systolic",
        size: 200,
      },
      {
        header: "Diastolic",
        accessorKey: "diastolic",
        size: 200,
      },
      {
        header: "Assigned To",
        accessorKey: "username",
        size: 300,
        Cell: ({ row }) => (
          <div
            className={
              row.original.username === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.userimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.userimage
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block">{row.original.username}</span>
            </p>
          </div>
        ),
      },
    ],
    []
  );

  //initialize the column order
  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    setSelectedBloodPressureIds(selectedIdsArray);
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_APPOINTMENT_MANAGEMENT")
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper crm-conversation-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Vitals")}
          />
          <div className="container-fluid px-lg-5">
            <BloodPressureHeader
              selectedItemIds={selectedBloodPressureIds}
              updateBulkHandler={updateBulkBloodPressureHandler}
              reloadList={getAllBloodPressure}
            />

            <VitalCommonheader activeOption="bloodpressure" />

            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={bloodPressureList}
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox in each row
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{ rowSelection, columnOrder }}
                  initialState={{ rowSelection, columnOrder }} // to set the initial state of column order
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>

          {/* modal and popup section  */}

          <SaveBloodPressurePopup
            selectedBloodPressureId={selectedBloodPressureId}
            setSelectedBloodPressureId={setSelectedBloodPressureId}
            afterActionClose={afterActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          <AssignUserModal
            moduleName="bloodpressure"
            afterModalClose={afterActionClose}
            selectedIds={selectedBloodPressureIds}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setRowSelection({});
              setSelectedBloodPressureIds([]);
            }}
          />

          <DeleteWarningModal
            onDelete={deleteBulkBloodPressureHandler}
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedBloodPressureIds([]);
            }}
            moduleName={t("blood pressure")}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default BloodPressureBody;
